<template>
  <div class="pub-table-search clearfix">
    <div class="pub-search-nav" v-if="queryParam != {}" :class="hasClass">
      <div class="p-header-item" v-for="(item, index) in allData" :key="index">
        <div class="p-header-item-title">{{ item.title }}</div>
        <div class="p-header-item-nav">
          <!-- 文本 -->
          <template v-if="!item.valueType || item.valueType == 'text'">
            <SearchText
              :data="queryParam[item.dataIndex]"
              :isBatch="item.isBatch"
              :fieldProps="
                item.fieldProps ? item.fieldProps : { placeholder: item.title }
              "
              @changeBack="data => onChangeText(data, item.dataIndex)"
            />
          </template>
          <!-- 公共select筛选 -->
          <template v-if="item.valueType == 'select'">
            <SearchSelect
              :data="queryParam[item.dataIndex]"
              :keyTime="item.keyTime"
              :allQuery="queryParam"
              :fieldProps="
                item.fieldProps ? item.fieldProps : { placeholder: item.title }
              "
              @changeBack="data => onChangeText(data, item.dataIndex)"
            />
          </template>
          <!-- 选月份 -->
          <template v-if="item.valueType == 'month'">
            <MonthDate
              :data="queryParam[item.dataIndex]"
              :fieldProps="
                item.fieldProps ? item.fieldProps : { placeholder: item.title }
              "
              @changeBack="data => onChangeText(data, item.dataIndex)"
            />
          </template>
          <!-- 时间段 -->
          <template v-if="item.valueType == 'range'">
            <StartendDate
              :data="queryParam[item.dataIndex]"
              :fieldProps="
                item.fieldProps ? item.fieldProps : { placeholder: item.title }
              "
              @changeBack="data => onChangeText(data, item.dataIndex)"
            />
          </template>
        </div>

        <!-- 交易金额 起 止 -->
        <div class="p-header-item-nav" v-if="item.type == 'numall'">
          <a-input
            v-model="queryParam[item.key]"
            placeholder="起始"
            class="p-header-numall"
            allow-clear
          />
          <div class="p-header-numall-text">至</div>
          <a-input
            v-model="queryParam[item.keyend]"
            placeholder="截止"
            class="p-header-numall"
            allow-clear
          />
        </div>
      </div>
      <div class="p-header-item p-header-btn">
        <a-button icon="reload" @click="reset">重置</a-button>
        <a-button type="primary" class="btn-blue" icon="search" @click="search"
          >查询</a-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import SearchText from "./children/SearchText.vue";
import SearchSelect from "./children/SearchSelect.vue";
import MonthDate from "./children/MonthDate.vue";
import StartendDate from "./children/StartendDate.vue";
export default {
  components: {
    SearchText,
    SearchSelect,
    MonthDate,
    StartendDate,
  },
  name: "TableSearch",
  props: {
    searchData: {
      type: Array,
      default: () => [],
    },
    isExport: {
      type: Boolean,
      default: false,
    },
    hasClass: {
      type: String,
      default: "", // align 长度固定
    },
  },
  data() {
    return {
      // 查询参数
      queryParam: {},
      // 原始参数，重置用
      allData: {},
      copyData: {},
      isClear: false,
    };
  },
  created() {
    // this.copyData = JSON.parse(JSON.stringify(this.searchData));
    // this.queryParam = JSON.parse(JSON.stringify(this.copyData));
    // console.log(this.queryParam);
  },
  watch: {
    searchData: {
      handler: function() {
        // console.log(1232);
        this.getSearch();
      },
      deep: true,
    },
  },
  mounted() {
    this.getSearch();
  },
  methods: {
    // 获取参数
    getSearch() {
      if (!this.searchData.length) return {};
      const newQuery = {};
      this.searchData.map(k => {
        newQuery[k.dataIndex] =
          k.fieldProps && k.fieldProps.defaultValue
            ? k.fieldProps.defaultValue
            : "";
      });
      // console.log(newQuery);
      this.queryParam = JSON.parse(JSON.stringify(newQuery));
      this.allData = this.searchData.map(v => ({
        ...v,
        keyTime: new Date().getTime(),
      }));
      // console.log(this.searchData);
      this.copyData = JSON.parse(JSON.stringify(newQuery));
    },
    // 查询
    search() {
      // console.log(this.queryParam);
      this.$emit("searchBack", this.queryParam);
    },
    // 重置
    reset() {
      // console.log(this.copyData);
      this.queryParam = JSON.parse(JSON.stringify(this.copyData));
      this.$emit("searchBack", this.queryParam);
    },
    // 改变搜索值时回调
    onChangeText(data, key) {
      // console.log(data);
      this.queryParam[key] = data;
      this.searchChange();
    },
    // 搜索改变时
    searchChange() {
      // console.log(this.queryParam);
      // console.log("搜索改变时", this.queryParam);
      // this.$emit("searchChange", this.queryParam);
      this.allData.forEach((element, index) => {
        if (
          element.valueType == "select" &&
          element.fieldProps &&
          element.fieldProps.associated &&
          element.fieldProps.associated.length
        ) {
          let num = 0;
          element.fieldProps.associated.forEach(v => {
            if (this.queryParam[v]) {
              num++;
            }
          });
          if (num == element.fieldProps.associated.length) {
            // console.log("时");
            this.allData[index].keyTime += 1;
            this.allData[index].fieldProps.ass_ok = true;
          }
        }
      });
    },
  },
};
</script>
<style lang="less">
@import "./style.less";
</style>
